import PropTypes from "prop-types";
import React from "react";
import { Box, Flex, Image, Text, Title, useMantineTheme } from "@mantine/core";
import { useStylesPage } from "../utils/mantine/useStylesPage";
import { useStylesStampResult } from "../utils/mantine/useStylesStampResult";
import { useStylesSubscriptionPage } from "../utils/mantine/useStylesSubscriptionPage";
import CustomAnchor from "./mantineCustomComponents/CustomAnchor";

const SubscriptionNotFound = ({ staticBasePath }) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  //css classes
  const { classes: classesPage } = useStylesPage();

  const { classes: classesStampResult } = useStylesStampResult();

  const { classes: classesSubscriptionPage } = useStylesSubscriptionPage();

  return (
    <Box
      className={`${classesStampResult.stamp} ${classesPage.page} subscription-success`}
    >
      <Flex
        className={classesPage.screen}
        direction="column"
        align={theme.flex.align.center}
      >
        <Box className={classesPage.header}>
          <Image
            src={`${staticBasePath}public/images/svg/vb-icon-not-verified.svg`}
            alt="Transaction not found"
            className={classesPage.pageHeaderIcon}
          />

          <Title mb={theme.margin.xsEm} order={1}>
            Transaction not found
          </Title>
          <Text className={classesSubscriptionPage.headerText}>
            Please contact{" "}
            <CustomAnchor
              componentClasses="link"
              text="support@vbase.com"
              href="mailto:support@vbase.com"
            />{" "}
            if this problem persists.
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};
SubscriptionNotFound.propTypes = {
  staticBasePath: PropTypes.string.isRequired,
};
export default SubscriptionNotFound;
